import React from 'react';
import InfoSection from '../components/InfoSection';

import { InfoDataTwo } from '../data/InfoData';

const Portail = () => {
  return <InfoSection {...InfoDataTwo} />;
};

export default Portail;